import { Component, EventEmitter, Input, Output } from '@angular/core'
import { DicomTag } from '../dicom-header.service'

/**
 * Presentational modal that shows a DICOM header as a filterable tag→value
 * table. Shared by the study view (tags supplied directly from the already-
 * parsed image) and the phantom-test view (tags fetched on demand). Owns no
 * data-loading logic — the host sets `tags`/`loading` and toggles `open`.
 */
@Component({
  selector: 'app-dicom-header-modal',
  templateUrl: './dicom-header-modal.component.html',
  styleUrls: ['./dicom-header-modal.component.scss'],
})
export class DicomHeaderModalComponent {
  @Input() open = false
  @Output() openChange = new EventEmitter<boolean>()

  /** Tags to display; `null`/empty shows the empty state (unless `loading`). */
  @Input() tags: DicomTag[] | null = null
  /** Show a spinner instead of the table (while a `.dcm` is being fetched). */
  @Input() loading = false
  @Input() title = 'DICOM Header'
  /** Optional context line, e.g. the image/series label. */
  @Input() subtitle = ''

  filter = ''

  get filteredTags(): DicomTag[] {
    const all = this.tags || []
    const f = this.filter.trim().toLowerCase()
    if (!f) return all
    return all.filter(
      (t) =>
        t.name.toLowerCase().includes(f) ||
        t.tag.toLowerCase().includes(f) ||
        (t.value || '').toLowerCase().includes(f),
    )
  }

  onOpenChange(open: boolean): void {
    this.open = open
    this.openChange.emit(open)
    if (!open) this.filter = ''
  }
}
